export const ACTION_GET_DOWLOADER_OR_SEND_EMAIL_MONETIZATIONS = "ACTION_GET_DOWLOADER_OR_SEND_EMAIL_MONETIZATIONS";
export const ACTION_POST_HISTORIC_ASSIGNMENT_DOWNLOAD_REPORT = "ACTION_POST_HISTORIC_ASSIGNMENT_DOWNLOAD_REPORT";
export const ACTION_POST_HISTORIC_ASSIGNMENT_SEND_REPORT = "ACTION_POST_HISTORIC_ASSIGNMENT_SEND_REPORT";
export const ACTION_GET_LIST_CONFIRM_MONETIZATION="ACTION_GET_LIST_CONFIRM_MONETIZATION";
export const ACTION_POST_HISTORIC_MONETIZATION = "ACTION_POST_HISTORIC_MONETIZATION";
export const ACTION_GET_START_MONETIZATIONS = "ACTION_GET_START_MONETIZATIONS";
export const ACTION_EMAIL_SEND_MONETIZATION = "ACTION_EMAIL_SEND_MONETIZATION";
export const ACTION_CONFIRM_MONETIZATIONS = "ACTION_CONFIRM_MONETIZATIONS";
export const ACTION_GET_LIST_REPORTS = "ACTION_GET_LIST_REPORTS";

// Star tax report
export const ACTION_GET_DOWLOAD_STAR_TAX_REPORT = "ACTION_GET_DOWLOAD_STAR_TAX_REPORT";

// Job status para polling
export const ACTION_GET_MONETIZATION_REPORT_JOB_STATUS = "ACTION_GET_MONETIZATION_REPORT_JOB_STATUS";
export const ACTION_GET_CONFIRM_MONETIZATION_JOB_STATUS = "ACTION_GET_CONFIRM_MONETIZATION_JOB_STATUS";
export const ACTION_GET_HISTORY_MONETIZATION_JOB_STATUS = "ACTION_GET_HISTORY_MONETIZATION_JOB_STATUS";
export const ACTION_GET_STAR_TAX_REPORT_JOB_STATUS = "ACTION_GET_STAR_TAX_REPORT_JOB_STATUS";

